
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import moment from 'moment';
import lazyInject from '@/di';
import WithdrawService from '@/services/withdraw.service';
import { WithdrawExamineStatus } from '@/common/enum/withdraw';
import { CAuditDetail } from '@/models/apply.model';
import { IAuditDetail } from '@/common/interface/apply';
import { handleNum } from '@/common/utils';
import UTILService from '@/services/utils.service';
import { AuthEnum } from '@/services/permission.service';
import ShopService from '@/services/shop.service';
import UserService from '@/services/user.service';
import ReviewDetail from './ReviewDetail.vue';

@Component({
  components: {
    'review-detail': ReviewDetail,
  },
})
export default class AuditDetails extends Vue {
  AuthEnum = AuthEnum;
  @lazyInject(WithdrawService)
  withdrawService!: WithdrawService;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(UserService)
  userService!: UserService;

  @lazyInject(UTILService)
  private utilService!: UTILService;

  @Ref('reviewDetail')
  reviewDetail?: ReviewDetail;

  selectedRowKeys: any = []; // Check here to configure the default column

  kalist: any[] = [];

  type = 'detail';

  handleNum = handleNum;

  WithdrawExamineStatus = WithdrawExamineStatus;

  statusList: WithdrawExamineStatus[] = [
    WithdrawExamineStatus.待审核,
    WithdrawExamineStatus.审核未通过,
    WithdrawExamineStatus.提现成功,
    WithdrawExamineStatus.提现中,
  ];

  mlist: any[] = [
    {
      label: '提现到门店',
      value: 'platform',
    },
    {
      label: '提现到品牌',
      value: 'ka',
    },
  ];

  filterForm: {
    withdrawal_no: string;
    status: any;
    pay_ts_start: string;
    pay_ts_end: string;
    apply_ts_start: string;
    apply_ts_end: string;
    verify_ts_start: string;
    verify_ts_end: string;
    account_no: string;
    ka_type: string;
    poi: string;
    shop_name: string;
    ka_id: any;
  } = {
    withdrawal_no: '',
    status: undefined,
    pay_ts_start: '',
    pay_ts_end: '',
    apply_ts_start: '',
    apply_ts_end: '',
    verify_ts_start: '',
    verify_ts_end: '',
    account_no: '',
    ka_type: 'platform',
    poi: '',
    shop_name: '',
    ka_id: '',
  };

  payts_data: any = [];
  applyts_data: any = [];
  verifyts_data: any = [];
  columns: any[] = [
    {
      title: '提现单号',
      dataIndex: 'withdrawalNo',
      align: 'center',
      width: 240,
    },
    {
      title: '总金额',
      dataIndex: 'money',
      align: 'center',
      scopedSlots: { customRender: 'money' },
      width: 120,
    },
    {
      title: '状态',
      dataIndex: 'statusStr',
      align: 'center',
      width: 120,
    },
    // {
    //   title: '提现渠道',
    //   dataIndex: 'channel',
    //   align: 'center',
    //   width: 120,
    //   scopedSlots: { customRender: 'channel' },
    // },
    {
      title: '提现账号',
      dataIndex: 'accountNo',
      align: 'center',
      scopedSlots: { customRender: 'accountNo' },
      width: 240,
    },
    {
      title: '申请时间',
      dataIndex: 'ctime',
      align: 'center',
      width: 200,
    },
    {
      title: '审核时间',
      dataIndex: 'verifyTime',
      align: 'center',
      scopedSlots: { customRender: 'verifyTime' },
      width: 200,
    },
    {
      title: '提现人',
      dataIndex: 'username',
      align: 'center',
      scopedSlots: { customRender: 'username' },
      width: 200,
    },
    {
      title: '转账时间',
      dataIndex: 'transferTime',
      align: 'center',
      scopedSlots: { customRender: 'transferTime' },
      width: 200,
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: 200,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
      width: 200,
    },
  ];

  platformColumns = [
    {
      title: '提现单号',
      dataIndex: 'withdrawalNo',
      align: 'center',
      width: 240,
    },
    {
      title: '提现状态',
      dataIndex: 'statusStr',
      align: 'center',
      width: 150,
    },
    {
      title: '门店名称',
      dataIndex: 'shopName',
      align: 'center',
      width: 300,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      align: 'center',
      width: 150,
    },
    {
      title: '城市',
      dataIndex: 'city',
      align: 'center',
      width: 150,
    },
    {
      title: '年费代运营',
      dataIndex: 'agentName',
      align: 'center',
      width: 150,
    },
    // {
    //   title: '提现渠道',
    //   dataIndex: 'channel',
    //   align: 'center',
    //   width: 120,
    //   scopedSlots: { customRender: 'channel' },
    // },
    {
      title: '提现账号',
      dataIndex: 'accountNo',
      align: 'center',
      scopedSlots: { customRender: 'accountNo' },
      width: 240,
    },
    {
      title: '申请时间',
      dataIndex: 'ctime',
      align: 'center',
      width: 240,
    },
    {
      title: '审核时间',
      dataIndex: 'verifyTime',
      align: 'center',
      width: 240,
    },
    {
      title: '转账时间',
      dataIndex: 'transferTime',
      align: 'center',
      width: 240,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      width: 240,
    },
  ];

  kaColumns = [
    {
      title: '提现单号',
      dataIndex: 'withdrawalNo',
      align: 'center',
      width: 240,
    },
    {
      title: '提现状态',
      dataIndex: 'statusStr',
      align: 'center',
      width: 150,
    },
    // {
    //   title: '提现渠道',
    //   dataIndex: 'channel',
    //   align: 'center',
    //   width: 120,
    //   scopedSlots: { customRender: 'channel' },
    // },
    {
      title: '提现账号',
      dataIndex: 'accountNo',
      align: 'center',
      scopedSlots: { customRender: 'accountNo' },
      width: 240,
    },
    {
      title: '品牌',
      dataIndex: 'kaName',
      align: 'center',
      width: 150,
    },
    {
      title: '申请时间',
      dataIndex: 'ctime',
      align: 'center',
      width: 240,
    },
    {
      title: '审核时间',
      dataIndex: 'verifyTime',
      align: 'center',
      width: 240,
    },
    {
      title: '转账时间',
      dataIndex: 'transferTime',
      align: 'center',
      width: 240,
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      scopedSlots: { customRender: 'action' },
      width: 240,
    },
  ];

  pagination = {
    total: 0,
    pageSize: 10,
    current: 1,
    onChange: this.paginationChange,
    showTotal: (total: any) => `共 ${total} 条`,
  };

  data = [];

  encryptAccount = '';

  loading = true;

  @Watch('$route')
  routeChange() {
    const {
      pay_ts_start,
      pay_ts_end,
      withdrawal_no,
      status,
      account_no,
      ka_type,
      poi,
      shop_name,
      ka_id,
      apply_ts_start,
      apply_ts_end,
      verify_ts_start,
      verify_ts_end,
      page,
      pageSize,
    } = this.$route.query;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || this.pagination.pageSize,
    };
    this.pagination.current = page ? Number(page) : 1;
    if (pay_ts_start && pay_ts_end) {
      params.pay_ts_start = pay_ts_start;
      params.pay_ts_end = pay_ts_end;
      this.filterForm.pay_ts_start = pay_ts_start as string;
      this.filterForm.pay_ts_end = pay_ts_end as string;
      this.payts_data = [
        moment(pay_ts_start as string),
        moment(pay_ts_end as string),
      ];
    }
    if (apply_ts_start && apply_ts_end) {
      params.apply_ts_start = apply_ts_start;
      params.apply_ts_end = apply_ts_end;
      this.filterForm.apply_ts_start = apply_ts_start as string;
      this.filterForm.apply_ts_end = apply_ts_end as string;
      this.applyts_data = [
        moment(apply_ts_start as string),
        moment(apply_ts_end as string),
      ];
    }
    if (verify_ts_start && verify_ts_end) {
      params.verify_ts_start = verify_ts_start;
      params.verify_ts_end = verify_ts_end;
      this.filterForm.verify_ts_start = verify_ts_start as string;
      this.filterForm.verify_ts_end = verify_ts_end as string;
      this.verifyts_data = [
        moment(verify_ts_start as string),
        moment(verify_ts_end as string),
      ];
    }
    if (ka_type) {
      this.filterForm.ka_type = ka_type as string;
      params.ka_type = ka_type;
    }
    if (poi) {
      this.filterForm.poi = poi as string;
      params.poi = poi;
    }
    if (shop_name) {
      this.filterForm.shop_name = shop_name as string;
      params.shop_name = shop_name;
    }
    if (ka_id) {
      this.filterForm.ka_id = Number(ka_id);
      params.ka_id = ka_id;
    }
    if (withdrawal_no) {
      this.filterForm.withdrawal_no = withdrawal_no as string;
      params.withdrawal_no = withdrawal_no;
    }
    if (status || status === '0') {
      this.filterForm.status = Number(status);
      params.status = status as string;
    }
    if (account_no) {
      this.filterForm.account_no = account_no as string;
      params.account_no = account_no;
    }
    if (ka_type === 'ka') {
      this.columns = this.kaColumns;
    } else {
      this.columns = this.platformColumns;
    }
    this.getkaWithdrawalRecord(params);
  }

  async LookShopDetail(title: string, encryptAccount: string) {
    const data = {
      encrypt_phone: encryptAccount,
      operate_type: title,
    };
    try {
      const res = await this.utilService.postPhoneDecrypt(data);
      if (res) {
        this.encryptAccount = res;
      }
    } catch (error) {
      this.$message.error('解密失败');
    }
  }

  paginationChange(page: number, pageSize: number) {
    const {
      pay_ts_start,
      pay_ts_end,
      withdrawal_no,
      status,
      account_no,
      ka_type,
      poi,
      shop_name,
      ka_id,
      apply_ts_start,
      apply_ts_end,
      verify_ts_start,
      verify_ts_end,
    } = this.filterForm;
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    const query: any = {
      page,
      pageSize,
    };
    if (pay_ts_start) {
      query.pay_ts_start = pay_ts_start;
    }
    if (pay_ts_end) {
      query.pay_ts_end = pay_ts_end;
    }
    if (withdrawal_no) {
      query.withdrawal_no = withdrawal_no;
    }
    if (status) {
      query.status = status;
    }
    if (account_no) {
      query.account_no = account_no;
    }
    if (ka_type) {
      query.ka_type = ka_type;
    }
    if (poi) {
      query.poi = poi;
    }
    if (shop_name) {
      query.shop_name = shop_name;
    }
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (apply_ts_start) {
      query.apply_ts_start = apply_ts_start;
    }
    if (apply_ts_end) {
      query.apply_ts_end = apply_ts_end;
    }
    if (verify_ts_start) {
      query.verify_ts_start = verify_ts_start;
    }
    if (verify_ts_end) {
      query.verify_ts_end = verify_ts_end;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  handleRowChange() {}

  async getWithdrawalCheck(val: any) {
    try {
      const res = await this.withdrawService.getWithdrawalCheck(val.id);
      if (res) {
        this.$message.success(res);
        this.routeChange();
      }
    } catch (error) {
      this.$message.error(error.message);
    }
  }

  go(routeName: string, id: any, no: string): void {
    // this.$router.push({
    //   name: routeName,
    //   params: {
    //     id,
    //     no,
    //     type: 'detail',
    //   },
    // });
    this.reviewDetail?.open(id, no);
  }

  async getKaList() {
    const id = this.userService.currentUser()?.id;
    const response = await this.shopService.postKaUserList(id);
    if (response) {
      this.kalist = response;
    }
  }

  onChange(dates: any) {
    this.payts_data = dates;
    this.filterForm.pay_ts_start = dates[0]?.format('YYYY-MM-DD');
    this.filterForm.pay_ts_end = dates[1]?.format('YYYY-MM-DD');
  }

  onChangeApply(dates: any) {
    this.applyts_data = dates;
    this.filterForm.apply_ts_start = dates[0]?.format('YYYY-MM-DD');
    this.filterForm.apply_ts_end = dates[1]?.format('YYYY-MM-DD');
  }

  onChangeVerify(dates: any) {
    this.verifyts_data = dates;
    this.filterForm.verify_ts_start = dates[0]?.format('YYYY-MM-DD');
    this.filterForm.verify_ts_end = dates[1]?.format('YYYY-MM-DD');
  }

  resetQuery() {
    this.filterForm = {
      withdrawal_no: '',
      status: undefined,
      pay_ts_start: '',
      pay_ts_end: '',
      account_no: '',
      apply_ts_start: '',
      apply_ts_end: '',
      verify_ts_start: '',
      verify_ts_end: '',
      ka_type: 'platform',
      poi: '',
      shop_name: '',
      ka_id: '',
    };
    this.pagination.current = 1;
    this.payts_data = [];
    this.applyts_data = [];
    this.verifyts_data = [];
    this.columns = this.platformColumns;
    const query: any = {};
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  search(val?: any) {
    const {
      pay_ts_start,
      pay_ts_end,
      status,
      withdrawal_no,
      account_no,
      ka_type,
      poi,
      shop_name,
      ka_id,
      apply_ts_start,
      apply_ts_end,
      verify_ts_start,
      verify_ts_end,
    } = this.filterForm;
    const query: any = {
      page: val ? this.pagination.current : 1,
      pageSize: this.pagination.pageSize,
    };
    if (pay_ts_start) {
      query.pay_ts_start = pay_ts_start;
    }
    if (pay_ts_end) {
      query.pay_ts_end = pay_ts_end;
    }
    if (status || Number(status) === 0) {
      query.status = status as string;
    }
    if (withdrawal_no) {
      query.withdrawal_no = withdrawal_no;
    }
    if (account_no) {
      query.account_no = account_no;
    }
    if (ka_type) {
      query.ka_type = ka_type;
    }
    if (poi) {
      query.poi = poi;
    }
    if (shop_name) {
      query.shop_name = shop_name;
    }
    if (ka_id) {
      query.ka_id = ka_id;
    }
    if (apply_ts_start) {
      query.apply_ts_start = apply_ts_start;
    }
    if (apply_ts_end) {
      query.apply_ts_end = apply_ts_end;
    }
    if (verify_ts_start) {
      query.verify_ts_start = verify_ts_start;
    }
    if (verify_ts_end) {
      query.verify_ts_end = verify_ts_end;
    }
    this.pagination.current = 1;
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  refresh() {}

  async getkaWithdrawalRecord(param: any) {
    const params: any = param;
    this.loading = true;
    if (params.pay_ts_start && params.pay_ts_end) {
      params.pay_ts_start = `${params.pay_ts_start} 00:00:00`;
      params.pay_ts_end = `${params.pay_ts_end} 23:59:59`;
    }
    if (params.apply_ts_start && params.apply_ts_end) {
      params.apply_ts_start = `${params.apply_ts_start} 00:00:00`;
      params.apply_ts_end = `${params.apply_ts_end} 23:59:59`;
    }
    if (params.verify_ts_start && params.verify_ts_end) {
      params.verify_ts_start = `${params.verify_ts_start} 00:00:00`;
      params.verify_ts_end = `${params.verify_ts_end} 23:59:59`;
    }
    if (params.ka_type === 'ka') {
      delete params.poi;
      delete params.shop_name;
      const res = await this.withdrawService.kaWithdrawalRecordKa(params);
      if (res) {
        this.loading = false;
        const auditDetailList = res.list.map((item: IAuditDetail) => CAuditDetail.from(item));
        this.data = auditDetailList;
        this.pagination.total = res.total;
      }
    } else {
      delete params.ka_id;
      const res = await this.withdrawService.kaWithdrawalRecord(params);
      if (res) {
        this.loading = false;
        const auditDetailList = res.list.map((item: IAuditDetail) => CAuditDetail.from(item));
        this.data = auditDetailList;
        this.pagination.total = res.total;
      }
    }
  }
  mounted() {
    this.routeChange();
    this.getKaList();
  }
}
